/**
 * @fileOverview Include this component to lazy load the Google chart code
 */
import { useState } from 'react'
import { loadScript } from './../../Utils/Misc'

var loadedGlobal = false

const ScriptLoader = ({ children, src }) => {
  var [loaded, setLoaded] = useState(loadedGlobal)
  var [loading, setLoading] = useState(false)
  if (loading) return null
  if (!loaded) {
    setLoading(true)
    loadScript(src).then(() => {
      setLoaded(true)
      setLoading(false)
    })
    return null
  }
  return children
}

export default ScriptLoader



// WEBPACK FOOTER //
// ./src/Components/ScriptLoader/index.js